"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitApplicationDate = exports.$tbApplicationDate = void 0;
var Algemeen = require("../Algemeen");
function InitApplicationDate() {
    exports.$tbApplicationDate = $('#tbApplicationDate');
    Algemeen.AddDatepicker(exports.$tbApplicationDate, null, null);
}
exports.InitApplicationDate = InitApplicationDate;
